// src/App.js
// [แก้ไข] เพิ่มการ import และ Route สำหรับ Temporary.js
// [แก้ไข] เพิ่ม Tab "ทดสอบระบบ"

import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate, Outlet } from 'react-router-dom'; 
import { Tabs } from 'antd'; 
import Leaderboard from './Leaderboard';
import Question from './Question';

// Import ไฟล์ใหม่ที่มีต่อท้ายด้วย -1
import SixSummary2 from './SixSummary-2'; 
import SevenSummary2 from './SevenSummary-2';
import EightSummary2 from './EightSummary-2';

// [แก้ไข] เพิ่ม import Temporary
import Temporary from './Temporary';

import './App.css';
import 'antd/dist/reset.css';

// 2. สร้าง "Layout" หลักที่จะมี Tabs
function MainLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  // รายการ Tab ของเรา
  const tabItems = [
    // --- ซ่อน 2 รายการนี้ ---
    // {
    //   key: '/',
    //   label: 'Leaderboard',
    // },
    // {
    //   key: '/question',
    //   label: 'คำตอบผู้แข่ง',
    // },
    // ---------------------------------
    {
      key: '/six-summary',
      label: 'ผลแข่งขันรอบชิงชนะเลิศรุ่น 6 ปี',
    },
    {
      key: '/seven-summary',
      label: 'ผลแข่งขันรอบชิงชนะเลิศรุ่น 7 ปี',
    },
    {
      key: '/eight-summary',
      label: 'ผลแข่งขันรอบชิงชนะเลิศรุ่น 8-9 ปี',
    },
    // [แก้ไข] เพิ่ม Tab ใหม่สำหรับ Temporary
    //{
    //  key: '/temporary',
    //  label: 'ทดสอบระบบ', 
    //},
  ];

  const onTabChange = (key) => {
    navigate(key); 
  };

  return (
    <div>
      <Tabs
        activeKey={location.pathname} 
        items={tabItems}
        onChange={onTabChange}
        type="card" 
        style={{ padding: '0 24px' }} 
      />
      
      <div style={{ padding: '0 24px' }}>
        <Outlet /> 
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Routes>
        
        {/* ให้ MainLayout เป็นตัวคุมหลัก */}
        <Route path="/" element={<MainLayout />}>
          
          {/* หน้าหลัก: redirect ไป /six-summary */}
          <Route 
            index={true} 
            element={<Navigate to="/six-summary" />} 
          />
          
          <Route path="six-summary" element={<SixSummary2 />} />
          <Route path="seven-summary" element={<SevenSummary2 />} />
          <Route path="eight-summary" element={<EightSummary2 />} />
          
          {/* [แก้ไข] เพิ่ม Route สำหรับ Temporary */}
          <Route path="temporary" element={<Temporary />} />
          
        </Route>

        {/* Route Catch-all */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
    </div>
  );
}

export default App;